import { User } from "../../../models/User";
import { getApiInstance } from "../../api";
import ApiClient from "../../apiClient";
import mutationWrapper from "../mutationWrapper";

export async function checkAuth(): Promise<User> {
  const res = await ApiClient.get(`/checkAuth`);
  return res.data;
}

export const useCheckAuth = mutationWrapper(checkAuth);
